import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import API_BASE_URL from "../config/api";

export default function Mocktest() {
  const [categories, setCategories] = useState([]);

  // 🔹 Fetch categories from API
  useEffect(() => {
    fetch(`${API_BASE_URL}/book_categories.php`, {
      method: "GET",
    })
      .then(async (res) => {
        const contentType = res.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          return res.json();
        } else {
          const text = await res.text();
          throw new Error("Invalid JSON response: " + text);
        }
      })
      .then((data) => {
        if (data.success && Array.isArray(data.categories)) {
          const updated = data.categories.map((cat) => ({
            id: cat.category_id,
            title: cat.category_name || "Untitled Category",
            img:
              cat.picture_url && cat.picture_url.trim() !== ""
                ? cat.picture_url
                : `${process.env.PUBLIC_URL}/assets/img/holding-educational.jpg`,
            courses: "Courses Available",
            discount: "Start",
          }));
          setCategories(updated);
        }
      })
      .catch((err) => {
        console.error("Error fetching categories:", err.message);
        setCategories([]);
      });
  }, []);

  // 🔹 Handle when user clicks a category card
  // const handleCardClick = async (categoryId) => {
  //   const user = sessionStorage.getItem("user");

  //   // ⚠️ If not logged in → show login alert
  //   if (!user) {
  //     await Swal.fire({
  //       title: "Please Login",
  //       text: "You need to sign in before starting a mock test.",
  //       icon: "warning",
  //       confirmButtonText: "Go to Login",
  //       confirmButtonColor: "#3085d6",
  //       showCancelButton: true,
  //       cancelButtonText: "Cancel",
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         navigate("/login");
  //       }
  //     });
  //     return;
  //   }

  //   // ✅ Logged in → Ask for test type
  //   const result = await Swal.fire({
  //     title: "Select Test Type",
  //     text: "Choose which type of mock test you’d like to start.",
  //     icon: "question",
  //     showCancelButton: true,
  //     confirmButtonText: "Master Test",
  //     cancelButtonText: "Chapter-wise Test",
  //     confirmButtonColor: "#007bff",
  //     cancelButtonColor: "#00a65a",
  //     reverseButtons: false, // ✅ Master Test first
  //   });

  //   if (result.isConfirmed) {
  //     navigate(`/mocktest/masterquiz/${categoryId}`);
  //   } else if (result.dismiss === Swal.DismissReason.cancel) {
  //     navigate(`/mocktest/chapterwise/${categoryId}`);
  //   }
  // };

  return (
    <>
      <section className="py-5">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="mb-0">Discover Mock Test Question Bank</h2>
          </div>

          <div className="row gx-4 gy-4">
            {categories.map((bundle) => (
              <div
                key={bundle.id}
                className="col-xl-3 col-lg-3 col-md-4 col-sm-6"
                style={{ display: "flex" }}
              >
                <div className="card w-100 mb-4" style={{ margin: "0 8px" }}>
                  <button
                    type="button"
                    className="p-0 border-0 bg-transparent text-start"
                    // onClick={() => handleCardClick(bundle.id)}
                  >
                    <img
                      src={bundle.img}
                      className="card-img-top rounded-top"
                      alt={bundle.title}
                    />
                    <div className="card-body align-to-left">
                      <h6 className="card-title mb-1">{bundle.title}</h6>
                      <p className="text-muted mb-2">{bundle.courses}</p>
                      <div className="d-flex align-items-center">
                       <Link to="/subscription"> <span className="badge bg-warning text-dark full-width">
                          {bundle.discount}
                        </span></Link>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
